import { Link } from 'react-router-dom';
import { Card } from '@dma/ui';
import type { ProjectDto } from '../application/dto/ProjectDto';
import { ProjectStatusBadge } from './ProjectStatusBadge';
import './ProjectCard.css';

export interface ProjectCardProps {
  project: ProjectDto;
}

export function ProjectCard({ project }: ProjectCardProps) {
  return (
    <Link to={`/projects/${project.slug}`} className="dma-project-card__link">
      <Card className="dma-project-card">
        <img
          className="dma-project-card__image"
          src={project.coverImage}
          alt={project.name}
          loading="lazy"
        />
        <div className="dma-project-card__body">
          <ProjectStatusBadge status={project.status} />
          <h3 className="dma-project-card__title">{project.name}</h3>
          <p className="dma-project-card__location">
            {project.province && project.city
              ? `${project.province} · ${project.city}`
              : project.province || project.city || 'موقعیت: نامشخص'}
          </p>
        </div>
      </Card>
    </Link>
  );
}
